export default "__VITE_ASSET__CC0cZpIj__"